import React, { useState, useEffect } from 'react'

import styled from '@emotion/styled'
import { getCookie } from 'cookies-next'
import { useSelector } from 'react-redux'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import withAuth from 'hoc/withAuth'
import { getFrontUserBookmark } from 'api'
import Header from 'components/Header'
import WishlistCard from 'components/WishlistSection/WishlistCard'
import Footer from 'components/Footer'
import { DEFAULT_LANG } from 'constants/lang'

const Wishlist = ({ initialData }) => {
  const token = useSelector((state) => state.auth.token)
  const {
    t,
    i18n: { language: lang },
  } = useTranslation()

  // 원래같으면 useMemo를 써서 라우터 변경할때마다 initialData를 갱신하는게 맞지만, 이 경우에는 하위 컴포넌트에서 props를 편집할(삭제) 필요가 있기때문에 useState를 쓰는게 더 좋음
  const [store, setStore] = useState(() => {
    let arr = []
    initialData.map((item) => item.product_id === null && arr.push(item))
    return arr
  })
  const [product, setProduct] = useState(() => {
    let arr = []
    initialData.map((item) => item.product_id !== null && arr.push(item))
    return arr
  })

  const empty = () => {
    return (
      <li className="icon-container">
        <h3>{t('no_wishlist')}</h3>
        <span className="material-icons-outlined">assignment_add</span>
      </li>
    )
  }

  const [didMount, setDidMount] = useState(false)
  const [tab, setTab] = useState('store')

  useEffect(() => {
    if (!didMount) return

    if (!token) return
    getFrontUserBookmark({ token, s_lang: lang }).then((res) => {
      if (res === 401) return
      let stroe = []
      res.data.map((item) => item.product_id === null && stroe.push(item))
      setStore(stroe)

      let product = []
      res.data.map((item) => item.product_id !== null && product.push(item))
      setProduct(product)
    })
  }, [lang])

  useEffect(() => {
    setDidMount(true)
  }, [])

  return (
    <>
      <Header title={t('wish_list')} />
      <Container>
        <Tab>
          <li
            onClick={() => setTab('store')}
            style={{ borderBottom: tab === 'store' ? '3px solid red' : 'none' }}
          >
            {t('stores')}
          </li>
          <li
            onClick={() => setTab('product')}
            style={{
              borderBottom: tab === 'product' ? '3px solid red' : 'none',
            }}
          >
            {t('products')}
          </li>
        </Tab>
        <Result>
          {tab === 'store'
            ? store.length > 0
              ? store
                  .reverse()
                  .map((item) => (
                    <WishlistCard
                      key={item.store_id}
                      data={item}
                      state={store}
                      setState={setStore}
                      t={t}
                    />
                  ))
              : empty()
            : product.length > 0
            ? product
                .reverse()
                .map((item) => (
                  <WishlistCard
                    key={item.product_id}
                    data={item}
                    state={product}
                    setState={setProduct}
                    t={t}
                  />
                ))
            : empty()}
        </Result>
      </Container>
      <Footer t={t} />
    </>
  )
}

export default withAuth(Wishlist)

export const getServerSideProps = async (ctx) => {
  const initialLang =
    ctx.locale === 'zh-cn' ? 'zh-Hans' : getCookie('lang', ctx) || DEFAULT_LANG
  const token = getCookie('token', ctx)
  const initialData = await getFrontUserBookmark(
    { token, s_lang: initialLang },
    'server'
  )

  return {
    props: {
      initialData: initialData === 401 ? null : initialData.data,
      ...(await serverSideTranslations(ctx.locale, ['common', 'product'])),
    },
  }
}

const Container = styled.main`
  padding-bottom: 72px;
`

const Tab = styled.ol`
  width: 100%;
  height: 48px;
  background-color: #f8f8f8;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  display: flex;

  li {
    width: 50%;
    height: 100%;
    line-height: 48px;
    text-align: center;
    font-weight: 700;
    cursor: pointer;
  }
`

const Result = styled.ul`
  padding: 16px;
  display: grid;
  grid-template-columns: calc(50% - 8px) calc(50% - 8px);
  grid-gap: 16px;

  a {
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  ul {
    height: calc(220px - 2px);
    padding: 10px;
  }

  .icon-container {
    width: calc(200% + 16px);
    text-align: center;
    margin-top: 72px;
  }

  .icon-container h3 {
    font-weight: 600;
  }

  .icon-container span {
    margin-top: 32px;
    font-size: 50px;
  }
`
